module.exports = __webpack_public_path__ + "img/close-dark.9c83996f.svg";